import { render } from "./DashboardBaseComposition.vue?vue&type=template&id=c708d8b8&scoped=true"
import script from "./DashboardBaseComposition.vue?vue&type=script&lang=js"
export * from "./DashboardBaseComposition.vue?vue&type=script&lang=js"

import "./DashboardBaseComposition.vue?vue&type=style&index=0&id=c708d8b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c708d8b8"]])

export default __exports__